//React
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import emailjs from '@emailjs/browser';
//Components
import Layout from '../../hocs/Layout';
import SwiperReviews from '../../components/aditional/SwiperReviews';
import { WhatsAppButton } from '../../components/aditional/WhatsApp';
import { reviews } from '../../helpers/Reviews';
//Styles
import '../../styles/static-pages.css';
//Icons
import { FaCheck } from "react-icons/fa6";
import { PiEnvelope } from "react-icons/pi";
import { HiOutlinePhone } from "react-icons/hi";
import { LuCalendarSearch } from "react-icons/lu";


const Home = () => {

	const { hash } = useLocation();
	const form = useRef();
    const [sendedEmail, setSendedEmail] = useState(false);
    const [openPriceForm, setOpenPriceForm] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('service_mwgltv9', 'template_sco1pyb', form.current, {
                publicKey: '22tKECBM3o4X0FoPS',
            })
            .then(
                () => {
                    console.log('SUCCESS!');
                    setSendedEmail(true);
                    form.current.reset();
                },
                (error) => {
                    console.log('FAILED...', error.text);
                },
            );
    };

    const toggleOpenForm = () => {
    	setOpenPriceForm(!openPriceForm);
    }

	useEffect(() => {
		window.scrollTo(0,0)
	}, []);

  	useEffect(() => {
    	if (hash) {
      		const element = document.querySelector(hash);
      		if (element) {
        		element.scrollIntoView({ behavior: 'smooth' });
      		}
    	}
  	}, [hash]);
	
	return (
		<Layout>
			<div className='container-banner-home'>
				<img src={require(`../../images/justicia.webp`)} alt='img-1' className='home-img-backg backg-1'/>
				<img src={require(`../../images/justicia.webp`)} alt='img-2' className='home-img-backg backg-2'/>
				<h2>Soluciones legales y Asesoramiento a la medida</h2>
				<p>Nos especializamos en todos los aspectos del derecho inmobiliario, desde la compra y venta de propiedades, hasta la 
				redacción de contratos, sucesiones patrimoniales y demás</p>
				<Link  to='https://calendly.com/veronicavegaabogada/30min' className='btn btn1' onClick={toggleOpenForm} style={{textDecoration:'none'}}>Reserve una Consulta</Link>
			</div>
			<div className='container-about-home' id='about'>
				<h2 className='home-titles'>Obtén la Ventaja que Necesitas</h2>
				<div className='contain-about-home'>
					<div className='about-home-img'>
						<img src={require(`../../images/about.webp`)} alt='about' />
					</div>
					<div className='about-home-info'>
						<div className='about-home-info-text'>
							<p className='about-home-text'>Abogada con más de 15 años de experiencia en el ámbito civil y comercial, 
								dedicada a ofrecer estrategias jurídicas claras, eficientes y orientadas a resultados, tanto para 
								particulares como para empresas.</p>
							<p className='about-home-text'>Mi trayectoria une una sólida formación académica con una práctica 
								profesional consolidada, siempre guiada por un enfoque personalizado, ético y de excelencia. Brindo 
								asesoramiento integral en casos complejos, desde litigios hasta mediaciones efectivas, priorizando 
								negociaciones ágiles, cobros seguros, minimización de costos y maximización de beneficios. Atención 
								en la Provincia de Buenos Aires y CABA.</p>
							<p className='about-home-text'>A lo largo de mi carrera he brindado asesoramiento completo a familias 
								en procesos de divorcio, alimentos, cuidado personal y régimen de visitas. También en procesos 
								hereditario, inscripciones de declaratorias y resolución de indivisiones, reclamos de canon locativo 
								en propiedades heredadas, con énfasis en la protección de bienes.</p>
							<p className='about-home-text'>Garantizo el blindaje de activos en acuerdos contractuales y 
								transferencias inmobiliarias, con validez notarial que maximizan la tranquilidad de los clientes.</p>
							<p className='about-home-text'>En el área comercial he acompañado a emprendedores, pymes y grandes 
								empresas colaborando en la confección y revisión de contratos, prevención de conflictos legales.</p>
							<p className='about-home-text'>Cuento con un equipo de profesionales altamente capacitados y de 
								absoluta confianza, que me permite ofrecer soluciones integrales en todas las áreas del derecho.
							</p>
						</div>
						<Link to='https://calendly.com/veronicavegaabogada/30min' className='btn btn1' style={{textDecoration:'none'}}>Reserve una Consulta</Link>
					</div>
				</div>
			</div>
			<div className='container-home-caracteristics' id='practice'>
				<h2 className='home-titles'>Nuestras Áreas de Práctica</h2>
				<div className='container-items'>
					<div className='caracteristics-items'>
						<div className='caracteristics-item-img'>
							<img src={require(`../../images/sucesiones.webp`)} alt='sucesiones' />
						</div>
						<div className='caracteristics-item-text'>
							<h4>Sucesiones</h4>
							<p>Asesoramiento y gestión en procesos sucesorios, garantizando una correcta transmisión del patrimonio y resolución de conflictos entre herederos.</p>
						</div>
					</div>
					<div className='caracteristics-items'>
						<div className='caracteristics-item-img'>
							<img src={require(`../../images/contratos.webp`)} alt='contratos' />
						</div>
						<div className='caracteristics-item-text'>
							<h4>Contratos</h4>
							<p>Redacción, revisión y negociación de contratos civiles y comerciales, asegurando claridad, cumplimiento y protección legal para todas las partes.</p>
						</div>
					</div>
					<div className='caracteristics-items'>
						<div className='caracteristics-item-img'>
							<img src={require(`../../images/ejecuciones.webp`)} alt='ejecuciones' />
						</div>
						<div className='caracteristics-item-text'>
							<h4>Ejecuciones</h4>
							<p>Representación en juicios ejecutivos para el cobro de deudas, cumplimiento forzado de obligaciones y defensa en procesos de ejecución.</p>
						</div>
					</div>
					<div className='caracteristics-items'>
						<div className='caracteristics-item-img'>
							<img src={require(`../../images/divorcios.webp`)} alt='divorcios' />
						</div>
						<div className='caracteristics-item-text'>
							<h4>Divorcios</h4>
							<p>Acompañamiento en procesos de divorcio, tanto de mutuo acuerdo como contenciosos, abarcando sus incidencias en materia de alimentos, cuidados personales y régimen de comunicación, resguardando los intereses patrimoniales y familiares.</p>
						</div>
					</div>
				</div>
			</div>
			<div className='container-home-support' id='practice'>
				<h2 className='home-titles titles-back'>Nuestros Servicios de Apoyo</h2>
				<div className='contain-home-support'>
					<div className='support-services-item'>
						<img src={require(`../../images/residenciales.webp`)} alt='residenciales' className='support-img' />
						<p>Transacciones Inmobiliarias Residenciales</p>
					</div>
					<div className='support-services-item'>
						<img src={require(`../../images/comerciales.webp`)} alt='comerciales' className='support-img' />
						<p>Transacciones Inmobiliarias Comerciales</p>
					</div>
					<div className='support-services-item'>
						<img src={require(`../../images/inmobiliario.webp`)} alt='inmobiliario' className='support-img' />
						<p>Litígios Inmobiliarios</p>
					</div>
					<div className='support-services-item'>
						<img src={require(`../../images/construccion.webp`)} alt='construccion' className='support-img' />
						<p>Litígio de Construcción</p>
					</div>
					<div className='support-services-item'>
						<img src={require(`../../images/impuesto.webp`)} alt='impuesto' className='support-img' />
						<p>Impuesto Inmobiliario</p>
					</div>
					<div className='support-services-item'>
						<img src={require(`../../images/zonificacion.webp`)} alt='zonificacion' className='support-img' />
						<p>Zonificación y Uso de la Tierra</p>
					</div>
				</div>
			</div>
			<div className='container-home-reviews'>
				<h2 className='home-titles'>Testimonios</h2>
				<div className='contain-home-reviews'>
					<SwiperReviews reviews={reviews} />
				</div>
    		</div>
            <form className='contact-form' ref={form} onSubmit={sendEmail} id='contact'>
                <div className='container-info-contact'>
                	<div className='contain-contact-paragraph'>
	                    <h2 className='titles-mid-blue'>Comunicate con Nosotros</h2> 
	                    <p>Si te gustaria conocer más, acerca de los servicios que ofrecemos, 
	                    comunícate con nosotros a través de los diferentes medios</p>
	                </div>
	                <div className='contain-info-contact'>
	                    <div className='info-contact'>
	                        <HiOutlinePhone className='contact-icon' />
	                        <p className='info-contact-text'>Número de Whatsapp</p>
	                    </div>
	                    <Link to='https://wa.me/+5491162180101?text=Hola,%20me%20interesan%20sus%20servicios%20legales.' target='_blank' className='info-contact-link' style={{textDecoration: 'none'}}>+54 9 11 6218-0101</Link>
	                </div>
	                <div className='contain-info-contact'>
	                    <div className='info-contact'>
	                        <PiEnvelope className='contact-icon' />
	                        <p className='info-contact-text'>Email</p>
	                    </div>
	                    <Link to='mailto:veronicavegaabogada@gmail.com' className='info-contact-link' style={{textDecoration: 'none'}}>veronicavegaabogada@gmail.com</Link>
	                </div>
	                <div className='contain-info-contact'>
	                    <div className='info-contact'>
	                        <LuCalendarSearch className='contact-icon' />
	                        <p className='info-contact-text'>Calendly</p>
	                    </div>
	                    <Link to='https://calendly.com/veronicavegaabogada/30min' target='_blank' className='info-contact-link' style={{textDecoration: 'none'}}>Reserve una consulta</Link>
	                </div>
	                <div className='container-contact-social'>
	                        <Link to='https://www.facebook.com/profile.php?id=61580040596978' className='contain-social-media facebook' target='_blank' style={{textDecoration:'none'}}>
						<div className='social-media-btn facebook'>
							<span></span>
						</div>
					</Link>
					<Link to='https://www.instagram.com/findcommers_ar/' className='contain-social-media instagram' target='_blank' style={{textDecoration:'none'}}>
						<div className='social-media-btn instagram'>
							<span></span>
						</div>
					</Link>
                </div>
                </div>
                <div className='contain-contact-form'>
                	<h2 className='contact-title'>Contáctanos</h2>
                    	<div className='contain-inputs-contact'>
                    	<div className='input-contact'>
                            <input
                                type='text'
                                name='user_name'
                                className='input-contact-form'
                                required
                            />
                            <span>Nombre</span>
                        </div>
                        <div className='input-contact'>
                            <input
                                type='email'
                                name='user_email'
                                className='input-contact-form'
                                required
                            />
                            <span>Email</span>
                        </div>
                        <div className='input-contact'>
                            <input 
                                type='text' 
                                name='subject' 
                                className='input-contact-form' 
                                required 
                            />
                            <span>Asunto</span>
                        </div>
                    <div className='input-contact-msg'>
                        <textarea name='message' className='input-contact-form' required></textarea>
                        <span>Mensaje</span>
                    </div>
                    <p className='required-fields'>Todos los campos son obligatorios</p>
                    <div className='container-submit-button'>
                        {sendedEmail ? (
                            <p className='submited-contact-button'>Enviado</p>
                        ) : (
                            <button type='submit' className='btn btn1'>
                                <span>Enviar</span>
                            </button>
                        )}
                    </div>
                    </div>
                </div>
            </form>
			<WhatsAppButton />
		</Layout>
	);
};

export default Home